import { IconProps } from 'interfaces';
import COLOR from 'constants/color';
import { isDarkMode } from 'utils/validators';

const ArrowRight = ({
  fill = COLOR.GRAY['900'],
  fillDarkMode = COLOR.SECONDARY.DARK_900,
  className = 'w-4 h-4',
  styles
}: IconProps) => {
  const fillColor = isDarkMode() ? fillDarkMode : fill;
  return (
    <svg
      className={styles || className}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      preserveAspectRatio='xMidYMid meet'>
      <path
        d='M5 12h14M12 5l7 7-7 7'
        stroke={fillColor}
        strokeWidth='2'
        strokeLinecap='round'
        strokeLinejoin='round'
        fill='none'
      />
    </svg>
  );
};

export default ArrowRight;
